import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'external-service-provider-destinations' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
